const transitionsIn = [
    //special
    {'name': 'none', 'displayName': 'None', 'professionalPremium': false, 'simplePremium': false, id: '32', inBoxAllow: true},
    { 'name': 'jackInTheBox', 'displayName': 'Jack In The Box', 'professionalPremium': true, 'simplePremium': true, id: '24' },
    { 'name': 'rollIn', 'displayName': 'Roll In', 'professionalPremium': false, 'simplePremium': true, id: '23' },
    { 'name': 'lightSpeedIn', 'displayName': 'Light Speed', 'professionalPremium': false, 'simplePremium': false, id: '12' },


    //bounce
    { 'name': 'bounceIn', 'displayName': 'Bounce In', 'professionalPremium': false, 'simplePremium': false, id: '0' },
    { 'name': 'bounceInDown', 'displayName': 'Bounce Down', 'professionalPremium': false, 'simplePremium': true, id: '1' },
    { 'name': 'bounceInUp', 'displayName': 'Bounce Up', 'professionalPremium': false, 'simplePremium': true, id: '2' },
    { 'name': 'bounceInRight', 'displayName': 'Bounce Right', 'professionalPremium': false, 'simplePremium': true, id: '3' },
    { 'name': 'bounceInLeft', 'displayName': 'Bounce Left', 'professionalPremium': false, 'simplePremium': true, id: '4' },


    //fade
    { 'name': 'fadeIn', 'displayName': 'Fade In', 'professionalPremium': false, 'simplePremium': true, id: '5' },
    { 'name': 'fadeInDown', 'displayName': 'Fade Down', 'professionalPremium': true, 'simplePremium': true, id: '6' },
    { 'name': 'fadeInUp', 'displayName': 'Fade Up', 'professionalPremium': true, 'simplePremium': true, id: '7' },
    { 'name': 'fadeInLeft', 'displayName': 'Fade Left', 'professionalPremium': true, 'simplePremium': true, id: '9' },
    { 'name': 'fadeInRight', 'displayName': 'Fade Right', 'professionalPremium': true, 'simplePremium': true, id: '8' },


    //flip
    // { 'name': 'flip', 'displayName': 'Flip', 'professionalPremium': true, id: '11' },
    { 'name': 'flipInX', 'displayName': 'Flip X', 'professionalPremium': false, 'simplePremium': true, id: '10' },
    { 'name': 'flipInY', 'displayName': 'Flip Y', 'professionalPremium': true, 'simplePremium': true, id: '11' },


    //rotate
    { 'name': 'rotateIn', 'displayName': 'Rotate In', 'professionalPremium': true, 'simplePremium': true, id: '13' },
    { 'name': 'rotateInDownLeft', 'displayName': 'Rotate Down Left', 'professionalPremium': false, 'simplePremium': true, id: '14' },
    { 'name': 'rotateInDownRight', 'displayName': 'Rotate Down Right', 'professionalPremium': false, 'simplePremium': true, id: '15' },
    { 'name': 'rotateInUpLeft', 'displayName': 'Rotate Up Left', 'professionalPremium': false, 'simplePremium': true, id: '16' },
    { 'name': 'rotateInUpRight', 'displayName': 'Rotate Up Right', 'professionalPremium': false, 'simplePremium': true, id: '17' },


    //zoom
    { 'name': 'zoomIn', 'displayName': 'Zoom In', 'professionalPremium': true, 'simplePremium': true, id: '18' },
    { 'name': 'zoomInDown', 'displayName': 'Zoom Down', 'professionalPremium': true, 'simplePremium': true, id: '19' },
    { 'name': 'zoomInUp', 'displayName': 'Zoom Up', 'professionalPremium': true, 'simplePremium': true, id: '20' },
    { 'name': 'zoomInLeft', 'displayName': 'Zoom Left', 'professionalPremium': false, 'simplePremium': true, id: '22' },
    { 'name': 'zoomInRight', 'displayName': 'Zoom Right', 'professionalPremium': false, 'simplePremium': true, id: '21' },

];

export default transitionsIn;